module.exports = __webpack_public_path__ + "static/media/airplaneLanding.8a5c9213.svg";